import React from "react";
import componentQueries from "react-component-queries";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import Login from "./pages/Login";
import ClubPage from "./pages/ClubPage";
import AdminLogin from "./pages/AdminLogin";
import UserLogin from "./pages/rushUser/UserLogin";
import RegistrationForm from "./pages/RegistrationForm";
import HideAndShowConfig from "./pages/HideAndShowConfig";
import EventRegistrationForm from "./pages/EventRegistrationForm";
import WebEventRegistrationForm from "./pages/WebEventRegistrationForm";
import WebAppRegistrationForm from "./pages/rushUser/WebAppRegistrationForm";

import GAListener from "./components/GAListener";
import { EmptyLayout, LayoutRoute, MainLayout } from "./components/Layout";
import "./styles/style.scss";
import "./styles/reduction.scss";
import config from "./config/local";
import { routes } from "./Routes.js";
import * as GeneralFunctions from "./GeneralFunctions";

const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split("/").pop()}`;
};

// Created the script tag,For Location Api
var script = document.createElement("script");
script.src = `https://maps.googleapis.com/maps/api/js?key=${config.locationApiKey}&libraries=places`;
script.defer = true;
document.head.appendChild(script);

class App extends React.Component {
  render() {
    const user = GeneralFunctions.getAuthUser();
    const permission = GeneralFunctions.getPermissions();
    return (
      <BrowserRouter basename={getBasename()}>
        <GAListener>
          <Switch>
            <LayoutRoute
              exact
              path="/hideAndShow/config"
              layout={EmptyLayout}
              component={(props) => <HideAndShowConfig {...props} />}
            />
            <LayoutRoute
              exact
              path="/*/form"
              layout={EmptyLayout}
              component={(props) => <RegistrationForm {...props} />}
            />
            <LayoutRoute
              exact
              path="/event/register/*"
              layout={EmptyLayout}
              component={(props) => <EventRegistrationForm {...props} />}
            />
            <LayoutRoute
              exact
              path="/web/event/register"
              layout={EmptyLayout}
              component={(props) => <WebEventRegistrationForm {...props} />}
            />
            <LayoutRoute
              exact
              path="/webapp/register"
              layout={EmptyLayout}
              component={(props) => <WebAppRegistrationForm {...props} />}
            />
            <LayoutRoute
              exact
              path="/login"
              layout={EmptyLayout}
              component={(props) => <Login {...props} />}
            />
            <LayoutRoute
              exact
              path="/userlogin"
              layout={EmptyLayout}
              component={(props) => <UserLogin {...props} />}
            />
            <LayoutRoute
              exact
              path="/admin/login"
              layout={EmptyLayout}
              component={(props) => <AdminLogin {...props} />}
            />
            <LayoutRoute
              exact
              path="/club/info"
              layout={EmptyLayout}
              component={(props) => <ClubPage {...props} />}
            />
            <MainLayout breakpoint={this.props.breakpoint}>
              {routes
                .filter((navItem) =>
                  navItem.forApps && user
                    ? navItem.forApps.includes(user.forApp || user.loggedInApp)
                    : navItem
                )
                .map(
                  (route, index) =>
                    permission === route.permission && (
                      <Route
                        key={index}
                        exact
                        path={route.path}
                        component={route.component}
                      />
                    )
                )}
            </MainLayout>
          </Switch>
        </GAListener>
      </BrowserRouter>
    );
  }
}

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: "xs" };
  }

  if (576 < width && width < 767) {
    return { breakpoint: "sm" };
  }

  if (768 < width && width < 991) {
    return { breakpoint: "md" };
  }

  if (992 < width && width < 1199) {
    return { breakpoint: "lg" };
  }

  if (width > 1200) {
    return { breakpoint: "xl" };
  }

  return { breakpoint: "xs" };
};

export default componentQueries(query)(App);
